import { Avatar, Box, Typography } from "@mui/material"
import { DamsAppAsset } from "../../assets/registry"
import { DamsColors } from "../styles/DamsColors"

function DamsLogoLabel({ title  }: {title? : string}): JSX.Element {
    return (
        <Box
            display={'flex'}
            alignItems={'center'}
            gap={'13px'}
            pl={'24px'}>
            <Avatar
                src={DamsAppAsset.image.ghs_logo}
                sx={styles.avatar}
                variant="square" />

            <Typography
                fontSize={16}
                fontFamily={'inter'}
                fontWeight={600}
                color={DamsColors.SideBar.SideBarText}
                variant="h6"
                noWrap>
                {title ?? title} 
            </Typography>
        </Box>
    )
}



const styles = {
    avatar: {
        width: '32px',
        Height: '32px'
    }
}


export { DamsLogoLabel }
